import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const CACHE_DOC = ["metrics", "cache"];
const STALE_MS = 5 * 60 * 1000;

const toMillis = (ts) => {
    if (!ts) return 0;
    if (typeof ts.toMillis === "function") return ts.toMillis();
    if (typeof ts.seconds === "number") return ts.seconds * 1000;
    return 0;
};

// Read the Cloud-Function-maintained metrics snapshot directly from Firestore.
// Returns null if the doc doesn't exist yet (cold project state) or the read
// fails. Callers handle the cold path by hitting triggerRefresh().
export const readMetricsSnapshot = async () => {
    try {
        const snap = await getDoc(doc(db, ...CACHE_DOC));
        if (!snap.exists()) return null;
        const data = snap.data();
        if (!data || !data.payload) return null;
        const generatedAtMs = toMillis(data.generatedAt);
        return {
            payload: data.payload,
            generatedAtMs,
            ageMs: generatedAtMs ? Date.now() - generatedAtMs : Infinity,
            isStale: !generatedAtMs || Date.now() - generatedAtMs > STALE_MS,
        };
    } catch (err) {
        console.warn("metrics snapshot read failed", err);
        return null;
    }
};

// Ping the HTTP endpoint. The function reads the same snapshot doc; if it's
// stale, it triggers a synchronous recompute + rewrite, then returns the fresh
// payload. Callers can await this when they want to swap in fresh data after
// the initial Firestore read.
export const triggerRefresh = async () => {
    try {
        const res = await fetch("/api/metrics");
        if (!res.ok) return null;
        return await res.json();
    } catch (err) {
        console.warn("metrics refresh trigger failed", err);
        return null;
    }
};
